import React from "react";
import "./Order_list_table.css";
// import { Form } from "react-router-dom";
// import { Table } from "react-bootstrap";
import { Form, Table } from "react-bootstrap";
import { variant_type } from "../../../../utils/common";
import { Link } from "react-router-dom";

function Order_list_table({
  order,
  selectedItems,
  setSelectedItems,
  setError,
}) {
  const handleCheckboxChange = (val) => {
    setError("");
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id); // use a unique ID or index
      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val]; // or just store val.id if needed
      }
    });
  };

  return (
    <>
      <div className="order_list_table Order_details_table Cart_Products_card d-none d-sm-block">
        <div className="table-responsive">
          <Table className="theme_bg_ternary_colour ">
            <tbody>
            
                <tr>
                  {/* <td>
                    <Form.Check
                      type="checkbox"
                      checked={selectedItems?.some(
                        (item) => item.id === val.id,
                      )}
                      onChange={() => handleCheckboxChange(val)}
                    />
                  </td> */}
                  <td>
                    <div className="row">
                      <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3 col-4">
                        <div className="img_holder">
                          <img
                            className="Product_img"
                            src={order?.Product?.image}
                            alt={"Product_img"}
                          />
                        </div>
                      </div>
                      <div className="col-xl-10 col-lg-9 col-md-9 col-sm-9 col-8">
                        <div className="info_text_holder">
                          <div>
                            <h4>{order?.Product?.name}</h4>

                            <h6>
                              {order?.Product?.variant_type_id ===
                                variant_type.Single && (
                                <>
                                  <strong>Metal:</strong>{" "}
                                  {order?.Product_Variant?.Metal?.name}
                                </>
                              )}

                              {order?.Product?.variant_type_id ===
                                variant_type.Double && (
                                <>
                                  <strong>Metal:</strong>{" "}
                                  {
                                    order?.Double_Variant?.Product_Variant?.Metal
                                      ?.name
                                  }
                                  , <strong>Size:</strong>{" "}
                                  {order?.Double_Variant?.Size?.name}{" "}
                                </>
                              )}

                              {order?.Product?.variant_type_id ===
                                variant_type.Triple && (
                                <>
                                  <strong>Metal:</strong>{" "}
                                  {
                                    order?.Triple_Variant?.Double_Variant
                                      ?.Product_Variant?.Metal?.name
                                  }
                                  , <strong>Size:</strong>{" "}
                                  {
                                    order?.Triple_Variant?.Double_Variant?.Size
                                      ?.name
                                  }
                                  , <strong>Diamond:</strong>{" "}
                                  {order?.Triple_Variant?.Diamond?.name}
                                </>
                              )}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>

                  <td style={{width:"50%"}}>
                    <div className="new_price_holder">
                      <p className="price_inner_text">
                        <span className="right_label">Price : </span>₹
                        {order?.selling_price}
                      </p>

                      <p className="price_inner_text">
                        <span className="right_label">Order Qty : </span>
                        {order?.quantity}
                      </p>

                      <p className="price_inner_text">
                        <span className="right_label">Total Price: </span>₹{" "}
                        {order?.quantity * order?.selling_price}
                      </p>
                    </div>

                    {/* <div className="Quantity_tr_holder">
                      <div className="price_holder">
                        <p className="mb-0" style={{ color: "#000" }}>
                          {order?.quantity} * ₹{order?.selling_price}
                        </p>
                      </div>
                    </div>
                    <div className="Quantity_tr_holder">
                      <div className="price_holder">
                        <p className="mb-0">
                          {" "}
                          Total: ₹ {order?.quantity * order?.selling_price}
                        </p>
                      </div>
                    </div> */}
                  </td>
                </tr>
            

            </tbody>
          </Table>
        </div>
      </div>

      <div className="d-block d-sm-none mobile_view_holder">
        {/* {order?.Product_Order_Details?.map((val) => ( */}
          <div className="mobile_product_card" key={order?.id}>
            <div className="row">
              <div className="col-12 mb-2">
                {/* <Form.Check
                  type="checkbox"
                  checked={selectedItems?.some((item) => item.id === val.id)}
                  onChange={() => handleCheckboxChange(val)}
                /> */}
              </div>
            </div>

            <Link
              to={`/product-details/${order?.Product?.id}`}
              className="text-decoration-none text-dark"
            >
              <div className="row justify-content-center">
                <div className="col-md-6 col-8 mb-3">
                  <div className="img_holder">
                    <img
                      className="Product_img"
                      src={order?.Product?.image}
                      alt={order?.Product?.name}
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="descn_holder">
                    <div className="left_div">
                      <h6 className="product_name mb-2">
                        {order?.Product?.name}
                      </h6>

                      <p className="mb-1">
                        {order?.Product?.variant_type_id ===
                          variant_type.Single && (
                          <>
                            <strong>Metal:</strong>{" "}
                            {order?.Product_Variant?.Metal?.name}
                          </>
                        )}

                        {order?.Product?.variant_type_id ===
                          variant_type.Double && (
                          <>
                            <strong>Metal:</strong>{" "}
                            {order?.Double_Variant?.Product_Variant?.Metal?.name}
                            <br />
                            <strong>Size:</strong>{" "}
                            {order?.Double_Variant?.Size?.name}
                          </>
                        )}

                        {order?.Product?.variant_type_id ===
                          variant_type.Triple && (
                          <>
                            <strong>Metal:</strong>{" "}
                            {
                              order?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name
                            }
                            <br />
                            <strong>Size:</strong>{" "}
                            {order?.Triple_Variant?.Double_Variant?.Size?.name}
                            <br />
                            <strong>Diamond:</strong>{" "}
                            {order?.Triple_Variant?.Diamond?.name}
                          </>
                        )}
                      </p>
                    </div>

                    <div className="price_details">
                      <div className="new_price_holder">
                        <p className="price_inner_text">
                          <span className="right_label">Price : </span>₹
                          {order?.selling_price}
                        </p>

                        <p className="price_inner_text">
                          <span className="right_label">Order Qty : </span>
                          {order?.quantity}
                        </p>

                        <p className="price_inner_text">
                          <span className="right_label">Total Price: </span>₹{" "}
                          {order?.quantity * order?.selling_price}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        {/* ))} */}
      </div>
    </>
  );
}

export default Order_list_table;
